"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppLayoutHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _composeStencilComponent = require("../../utils/composeStencilComponent");
var _helperComponents = require("./helperComponents");
var _react2 = require("@emotion/react");
const AppLayoutHeaderBase = _ref => {
  let {
    children,
    ...viewProps
  } = _ref;
  return (0, _react2.jsx)(_helperComponents.HeaderView, viewProps, children);
};
const AppLayoutHeader = exports.AppLayoutHeader = (0, _composeStencilComponent.composeStencilComponent)({
  baseComponent: AppLayoutHeaderBase,
  displayName: 'AppLayoutHeader',
  description: 'Header element to wrap <PageHeader> in app layout.'
});